import useHook from './hooks'
import styles from './style.module.scss'
import TableAntd from '../../components/TableAntd'
import { Button, Col, Form, Modal, Row, Space } from 'antd'
import CustomTextarea from '../../components/CustomTextarea'
import { orderDetailLinkRender } from '../orderassurance/Lander'
import { WarningFilled } from '@ant-design/icons'

export default function AddPaymentRequest() {
  const {
    dataSource,
    form,
    totalPrice,
    enterpriseInfo,
    onChangeCheck,
    handleClosePage,
    handleSubmit,
    handleFormDataChange,
    isSubmitButtonLoading,
    isSubmitFailure,
    closeSubmitFailureModal,
    isDisabledSubmit,
    submitFailInfo,
  } = useHook()

  // 三要素审核状态
  // const tagRender = (text: string, type: number) => {
  //   const successTag = (
  //     <span
  //       style={{
  //         color: '#069D18',
  //         backgroundColor: '#E0F5D7',
  //         borderRadius: '4px',
  //         padding: '0 4px',
  //       }}
  //     >
  //       复核通过
  //     </span>
  //   )
  //   const errorTag = (
  //     <span
  //       style={{
  //         color: '#CD3A15',
  //         backgroundColor: '#FBDEDE',
  //         borderRadius: '4px',
  //         padding: '0 4px',
  //       }}
  //     >
  //       异常
  //     </span>
  //   )
  //   return (
  //     <span>
  //       {text} {type === 1 ? successTag : type === 2 ? errorTag : ''}
  //     </span>
  //   )
  // }
  const formConfig = {
    订单明细: {
      columns: [
        {
          key: 'orderNo',
          dataIndex: 'orderNo',
          title: '客户订单号',
          render: orderDetailLinkRender,
        },
        {
          key: 'customer',
          dataIndex: 'customer',
          title: '客户名称',
        },
        {
          key: 'platform',
          dataIndex: 'platform',
          title: '下单平台',
        },
        {
          key: 'finalPrice',
          dataIndex: 'finalPrice',
          title: '最终结算金额',
        },
        {
          key: 'signVoucherState',
          dataIndex: 'signVoucherState',
          title: '签收凭证',
          // render: (text: string, record: any) =>
          //   tagRender(text, record.signVoucherStateReview),
        },
        {
          // 回款进度 0-未回款 1-部分回款 2-全部回款
          key: 'returnState',
          dataIndex: 'returnState',
          title: '客户回款',
          // render: (text: string, record: any) =>
          //   tagRender(text, record.customerReturnProgressReview),
        },
        {
          key: 'paymentMethodList',
          dataIndex: 'paymentMethodList',
          title: '回款方式',
          render: (text: any) => {
            return <span>{text?.join(',')}</span>
          },
        },
        {
          key: 'accountOpenInvoiceStatus',
          dataIndex: 'accountOpenInvoiceStatus',
          title: '供应商开票',
          // render: (text: string, record: any) =>
          //   tagRender(text, record.orderSupplierOpenInvoiceStatusReview),
        },
      ],
    },
  }

  return (
    <div className={styles['contianer']}>
      <div className={styles['order-detail']}>
        <Row justify="space-between" className={styles['header']}>
          <span>订单明细 （{dataSource.length}）</span>
          <span className="gray-info">核对无误后提交</span>
        </Row>
        <div className={styles['table-container']}>
          <TableAntd
            dataSource={dataSource}
            listColumn={formConfig['订单明细'].columns}
            selfAdaptScroll
            showSize
            loading={false}
            onChangeCheck={onChangeCheck}
          ></TableAntd>
        </div>
      </div>
      <div className={styles['order-info']}>
        <div className={styles['header']}>付款单信息</div>
        <Form
          form={form}
          className={styles['content']}
          onValuesChange={handleFormDataChange}
        >
          <Row gutter={20}>
            <Col span={8}>
              <Form.Item label="提交人">
                {enterpriseInfo?.enterpriseName}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="付款单金额">{totalPrice.toFixed(2)}</Form.Item>
            </Col>
          </Row>
          {/* 删除备注功能 */}
          {/* <Row gutter={20} className={styles['remark']}>
            <Col span={8}>
              <Form.Item label="供应商备注" name="remark">
                <CustomTextarea
                  maxLength={140}
                  placeholder="请输入备注"
                  rows={5}
                ></CustomTextarea>
              </Form.Item>
            </Col>
          </Row> */}
        </Form>
      </div>
      <div className={styles['bottom-buttons-container']}>
        <Space>
          <div>
            <Button disabled={isSubmitButtonLoading} onClick={handleClosePage}>
              取消
            </Button>
          </div>
          <Button
            type="primary"
            onClick={handleSubmit}
            className={styles['button-item']}
            loading={isSubmitButtonLoading}
            disabled={isDisabledSubmit}
          >
            提交
          </Button>
        </Space>
      </div>
      {/* 提交付款申请失败 */}
      <Modal
        closable={false}
        open={isSubmitFailure}
        width={'400px'}
        style={{ top: '25%' }}
        title={
          <span>
            <WarningFilled style={{ color: '#F7AD19', marginRight: '8px' }} />
            提交失败
          </span>
        }
        footer={[
          <Button
            type="primary"
            onClick={() => closeSubmitFailureModal()}
            key="baseLayoutConfirmBtn"
          >
            确认
          </Button>,
        ]}
      >
        <div style={{ color: '#101010' }}>
          <div>{submitFailInfo.time}</div>
          <div>您账上的总应付金额为：{submitFailInfo.countAmount}</div>
          <div>您正在申请付款中的金额为：{submitFailInfo.countApplyAmount}</div>
          <div>您本次申请付款金额为：{submitFailInfo.applyAmount}</div>
          <div>请联系咸亨工作人员，核对您账上的应付余额！以便继续申请付款</div>
        </div>
      </Modal>
    </div>
  )
}
import useHook from './hooks'
import styles from './style.module.scss'
import TableAntd from '../../components/TableAntd'
import { Button, Col, Form, Modal, Row, Space } from 'antd'
import CustomTextarea from '../../components/CustomTextarea'
import { orderDetailLinkRender } from '../orderassurance/Lander'
import { WarningFilled } from '@ant-design/icons'

export default function AddPaymentRequest() {
  const {
    dataSource,
    form,
    totalPrice,
    enterpriseInfo,
    onChangeCheck,
    handleClosePage,
    handleSubmit,
    handleFormDataChange,
    isSubmitButtonLoading,
    isSubmitFailure,
    closeSubmitFailureModal,
    isDisabledSubmit,
    submitFailInfo,
  } = useHook()

  // 三要素审核状态
  // const tagRender = (text: string, type: number) => {
  //   const successTag = (
  //     <span
  //       style={{
  //         color: '#069D18',
  //         backgroundColor: '#E0F5D7',
  //         borderRadius: '4px',
  //         padding: '0 4px',
  //       }}
  //     >
  //       复核通过
  //     </span>
  //   )
  //   const errorTag = (
  //     <span
  //       style={{
  //         color: '#CD3A15',
  //         backgroundColor: '#FBDEDE',
  //         borderRadius: '4px',
  //         padding: '0 4px',
  //       }}
  //     >
  //       异常
  //     </span>
  //   )
  //   return (
  //     <span>
  //       {text} {type === 1 ? successTag : type === 2 ? errorTag : ''}
  //     </span>
  //   )
  // }
  const formConfig = {
    订单明细: {
      columns: [
        {
          key: 'orderNo',
          dataIndex: 'orderNo',
          title: '客户订单号',
          render: orderDetailLinkRender,
        },
        {
          key: 'customer',
          dataIndex: 'customer',
          title: '客户名称',
        },
        {
          key: 'platform',
          dataIndex: 'platform',
          title: '下单平台',
        },
        {
          key: 'finalPrice',
          dataIndex: 'finalPrice',
          title: '最终结算金额',
        },
        {
          key: 'signVoucherState',
          dataIndex: 'signVoucherState',
          title: '签收凭证',
          // render: (text: string, record: any) =>
          //   tagRender(text, record.signVoucherStateReview),
        },
        {
          // 回款进度 0-未回款 1-部分回款 2-全部回款
          key: 'returnState',
          dataIndex: 'returnState',
          title: '客户回款',
          // render: (text: string, record: any) =>
          //   tagRender(text, record.customerReturnProgressReview),
        },
        {
          key: 'paymentMethodList',
          dataIndex: 'paymentMethodList',
          title: '回款方式',
          render: (text: any) => {
            return <span>{text?.join(',')}</span>
          },
        },
        {
          key: 'accountOpenInvoiceStatus',
          dataIndex: 'accountOpenInvoiceStatus',
          title: '供应商开票',
          // render: (text: string, record: any) =>
          //   tagRender(text, record.orderSupplierOpenInvoiceStatusReview),
        },
      ],
    },
  }

  return (
    <div className={styles['contianer']}>
      <div className={styles['order-detail']}>
        <Row justify="space-between" className={styles['header']}>
          <span>订单明细 （{dataSource.length}）</span>
          <span className="gray-info">核对无误后提交</span>
        </Row>
        <div className={styles['table-container']}>
          <TableAntd
            dataSource={dataSource}
            listColumn={formConfig['订单明细'].columns}
            selfAdaptScroll
            showSize
            loading={false}
            onChangeCheck={onChangeCheck}
          ></TableAntd>
        </div>
      </div>
      <div className={styles['order-info']}>
        <div className={styles['header']}>付款单信息</div>
        <Form
          form={form}
          className={styles['content']}
          onValuesChange={handleFormDataChange}
        >
          <Row gutter={20}>
            <Col span={8}>
              <Form.Item label="提交人">
                {enterpriseInfo?.enterpriseName}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="付款单金额">{totalPrice.toFixed(2)}</Form.Item>
            </Col>
          </Row>
          {/* 删除备注功能 */}
          {/* <Row gutter={20} className={styles['remark']}>
            <Col span={8}>
              <Form.Item label="供应商备注" name="remark">
                <CustomTextarea
                  maxLength={140}
                  placeholder="请输入备注"
                  rows={5}
                ></CustomTextarea>
              </Form.Item>
            </Col>
          </Row> */}
        </Form>
      </div>
      <div className={styles['bottom-buttons-container']}>
        <Space>
          <div>
            <Button disabled={isSubmitButtonLoading} onClick={handleClosePage}>
              取消
            </Button>
          </div>
          <Button
            type="primary"
            onClick={handleSubmit}
            className={styles['button-item']}
            loading={isSubmitButtonLoading}
            disabled={isDisabledSubmit}
          >
            提交
          </Button>
        </Space>
      </div>
      {/* 提交付款申请失败 */}
      <Modal
        closable={false}
        open={isSubmitFailure}
        width={'400px'}
        style={{ top: '25%' }}
        title={
          <span>
            <WarningFilled style={{ color: '#F7AD19', marginRight: '8px' }} />
            提交失败
          </span>
        }
        footer={[
          <Button
            type="primary"
            onClick={() => closeSubmitFailureModal()}
            key="baseLayoutConfirmBtn"
          >
            确认
          </Button>,
        ]}
      >
        <div style={{ color: '#101010' }}>
          <div>{submitFailInfo.time}</div>
          <div>您账上的总应付金额为：{submitFailInfo.countAmount}</div>
          <div>您正在申请付款中的金额为：{submitFailInfo.countApplyAmount}</div>
          <div>您本次申请付款金额为：{submitFailInfo.applyAmount}</div>
          <div>请联系咸亨工作人员，核对您账上的应付余额！以便继续申请付款</div>
        </div>
      </Modal>
    </div>
  )
}
